<template>
<transition name="fade">
  <div class="absolute pointer-events-none" v-in-viewport >
    <figure :class="figstyles">
      <img
        :src="
          'https://api.caseyhouse.com/sendyourlove/assets/' +
            hash +
            '?key=thumbnail'
        "
        :data-zoom-src="'https://api.caseyhouse.com/sendyourlove/assets/'+hash+'?key=medium'"
        data-zoom-caption="hi"
        :alt="artist"
        :data-content="artist"
        style="height:auto"
        data-zoomable="true"
        class="mb-12"
      />
      <figcaption class="absolute" v-show="expanded">{{artist}}</figcaption>
    </figure>
    <slot></slot>
  </div>
  </transition>
</template>

<script>
// import mediumZoom from 'medium-zoom'

export default {
  name: "SmallHeart",
  props: ["artist", "hash", "src-watermarked","figstyles"],
  data(){
    return{
      expanded:false
    }
  },
  mounted(){
  }
  
};
</script>

<style scoped>

figcaption{
  bottom:.45rem;
  left:1.25rem;
}

img{
  width:75%;
}

.floatingheart{
  opacity:0;
  transition: opacity .5s linear;
}

.floatingheart.in-viewport{
  opacity: 1;
}

</style>
